import { inAndroid, inBaiduBox, inIOS, inMobile, inQQ, inSafari, inWechat } from '@/data/runtime'
import { main } from '@/main'
import { captureException, debounce, errorTips } from '@/utils/Decorators'

import { BaseModule } from '../base'

export interface IDownloadModel {}

/** 下载能力 */
export class DownloadModule extends BaseModule<IDownloadModel> {
    protected initData(): IDownloadModel {
        return {}
    }

    /** 微信环境监察 */
    async precheckEnvInWechat(): Promise<void> {
        const { search } = location
        // let redirectEnv = inWechat || (inQQ && inIOS) || inBaiduBox
        let redirectEnv = inWechat || inBaiduBox
        // ? 已加载下载链接跳过
        if (search.indexOf('download=') !== -1) return
        if (search.indexOf('precheck=') !== -1) return
        // ? 非需要跳转外部浏览器下载跳过
        if (!redirectEnv) return
        // > execute
        this.exec()
    }

    /** 下载 */
    @captureException('download-module')
    @errorTips()
    @debounce()
    async exec(): Promise<void> {
        const { gameId, channelId } = this.parent.app
        let osType: number
        if (inAndroid || !inMobile) osType = 2
        else osType = 1
        // 人工定制页面:https://init.sdk.v2.dakongy.com
        if (['6235908887072643', '6219309872643'].includes(gameId)) {
            await main.app.download.downloadForOther()
            return
        }
        // > transform
        const { data } = await this.$apis.common.getGameDetail({ gameId, channelId, osType })
        const { gameDetail } = data
        await main.app.download.download(gameDetail.gameId, channelId, gameDetail.icon1, gameDetail, gameDetail.osType)
    }
}
